export default __webpack_public_path__ + "static/Dancing_Cow-a5ffbde74b037a4dfdbcdabdd536d068.gif";